module.exports = __webpack_public_path__ + "static/img/newscc.fc48b18.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newscc.png
// module id = eQT2
// module chunks = 45